module.exports = __webpack_public_path__ + "static/media/emma-frost-win.fc9f69d9.png";